import AntdAvatar from 'components/Avatar'
import {
  AntdSpan,
  CandCountSpan,
  CandidateCountSpan,
  CandidateFlex,
  CandidatesDiv,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import React, { useEffect, useState } from 'react'

const CandidateDetails = ({
  text = 'Candidates',
  selectedCandidate,
  count,
  isBulk,
}) => {
  const [candidateList, setCandidateList] = useState([])

  useEffect(() => {
    setCandidateList(
      selectedCandidate
        ?.map(item => {
          return {
            profileUrl: item?.student?.profileUrl,
            name: item?.student?.firstName,
          }
        })
        ?.slice(0, 10)
    )
  }, [selectedCandidate])

  return (
    <CandidateFlex column>
      <CandidatesDiv>
        {text} <CandidateCountSpan>({count})</CandidateCountSpan>
      </CandidatesDiv>
      <div>
        {candidateList?.map((item, key) => (
          <AntdSpan key={key + item?.name}>
            <AntdAvatar
              size="50"
              padding={item?.profileUrl ? '0px' : '8px'}
              IconName={item?.name?.charAt(0)?.toUpperCase()}
              src={item?.profileUrl}
            />
          </AntdSpan>
        ))}
        {count > 10 && (
          <AntdSpan>
            <CandCountSpan>+{Number(count) - 10}</CandCountSpan>
          </AntdSpan>
        )}
      </div>
    </CandidateFlex>
  )
}

export default CandidateDetails
